const SENSITIVE_KEY =
  /(authorization|cookie|password|passwd|secret|token|api[_-]?key|dsn)/i;
const BEARER_VALUE = /Bearer\s+[A-Za-z0-9._~+/=-]+/gi;
const URL_SECRET =
  /([?&](?:token|access_token|refresh_token|api_key|key|secret|password)=)[^&#\s]*/gi;
const REDACTED = '[Filtered]';

export function sanitizeTelemetryValue(
  value: unknown,
  key = '',
  depth = 0
): unknown {
  if (SENSITIVE_KEY.test(key)) return REDACTED;
  if (depth > 6) return '[Truncated]';
  if (typeof value === 'string') {
    return value
      .replace(BEARER_VALUE, `Bearer ${REDACTED}`)
      .replace(URL_SECRET, `$1${REDACTED}`);
  }
  if (Array.isArray(value))
    return value.map((entry) => sanitizeTelemetryValue(entry, '', depth + 1));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([entryKey, entryValue]) => [
        entryKey,
        sanitizeTelemetryValue(entryValue, entryKey, depth + 1)
      ])
    );
  }
  return value;
}

export function sanitizeTelemetryRecord<T>(record: T): T {
  return sanitizeTelemetryValue(record) as T;
}
